var _defs, _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXl: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    viewBox: "641 -895.2 16.000307 15.001143",
    width: 16.000307,
    height: 15.001143,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Produced by OmniGraffle 7.12.1 \n    ", /*#__PURE__*/React.createElement("dcDate", null, "2020-10-16 14:00:17 +0000"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1",
    strokeDasharray: "none",
    fill: "none",
    stroke: "none",
    strokeOpacity: 1,
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Canvas 1"), /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1: Layer 1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 643.8647 -880.8489 C 643.7867 -880.4049 644.2247 -880.0579 644.6107 -880.2559 L 649.0007 -882.5119 L 653.3897 -880.2559 C 653.7757 -880.0579 654.2137 -880.4049 654.1357 -880.8479 L 653.3057 -885.5779 L 656.8287 -888.9339 C 657.1577 -889.2479 656.9867 -889.8219 656.5457 -889.8839 L 651.6477 -890.5799 L 649.4637 -894.9069 C 649.37874 -895.0859 649.1983 -895.2 649.0002 -895.2 C 648.802 -895.2 648.6216 -895.0859 648.5367 -894.9069 L 646.3527 -890.5789 L 641.4547 -889.8829 C 641.0137 -889.8209 640.8427 -889.2469 641.1717 -888.9329 L 644.6947 -885.5769 L 643.8647 -880.8469 Z M 648.7697 -883.6159 L 645.0837 -881.7219 L 645.7777 -885.6789 C 645.8107 -885.8638 645.7496 -886.0531 645.6147 -886.1839 L 642.7087 -888.9539 L 646.7607 -889.5299 C 646.931 -889.5556 647.0778 -889.6632 647.1537 -889.8179 L 649.0007 -893.4759 L 650.8467 -889.8179 C 650.9225 -889.6632 651.06935 -889.5556 651.2397 -889.5299 L 655.2917 -888.9549 L 652.3857 -886.1849 C 652.2503 -886.054 652.1891 -885.8642 652.2227 -885.6789 L 652.9167 -881.7219 L 649.2307 -883.6159 C 649.08604 -883.6904 648.9143 -883.6904 648.7697 -883.6159 Z",
    fill: "#00bfec"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.7c29feeb7985010d68069baf0da0ab7e.svg";
export { ForwardRef as ReactComponent };